export const breakpoints = {
  mobile: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
} as const;

export const media = {
  mobile: `@media (max-width: ${breakpoints.mobile}px)`,
  tablet: `@media (max-width: ${breakpoints.tablet}px)`,
  laptop: `@media (max-width: ${breakpoints.laptop}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop + 1}px)`,
  notMobile: `@media (min-width: ${breakpoints.mobile + 1}px)`,
  notTablet: `@media (min-width: ${breakpoints.tablet + 1}px)`,
  notLaptop: `@media (min-width: ${breakpoints.laptop + 1}px)`,
} as const;
